import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
export function Card({
  children,
  className = '',
  hover = false,
  padding = 'md'
}: CardProps) {
  const paddingStyles = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6'
  };
  return <div className={`
        bg-white rounded-xl border border-gray-100 shadow-card
        ${hover ? 'transition-shadow duration-300 hover:shadow-card-hover' : ''}
        ${paddingStyles[padding]}
        ${className}
      `} data-id="element-796">
      {children}
    </div>;
}